module.exports = __webpack_public_path__ + "static/media/slope.b28b9e10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/homepage/slope.svg
// module id = 870
// module chunks = 21